import { defineStore } from 'pinia';
import { f7 } from 'framework7-vue';
import { useKeycloakStore } from './keycloak.js';
import api from '../api/client.js';

const path = import.meta.env.VITE_APP_URL+ 'account/user';
const doc_path = import.meta.env.VITE_APP_URL + 'documents';
export const useAccountStore = defineStore('account', {
  
  state: () => ({
    userByAccountNumber: '',
    claimUserByAccountNumber: '',
    accountnumber: '',
    userDetail: '',
    primaryAccount: '',
    businessAccount: '',
    getusererror: '',
    users: '',
    searchedUser: '',
    userAccount: '',
    document: '',
    documentList: [],
    myGroupList: [],
    userGroupList: [],
    groupUserGroupList: [],
  }),
  persist: true,

  getters: {
    // userByAccountNumber: (state) => state.userByAccountNumber,
    // claimUserByAccountNumber: (state) => state.claimUserByAccountNumber,
  },

  actions: {
    async createNewUservocashAccounts() {
      const { default: axios } = await import('axios');
      
      axios({
        url: `${path}/create`,
        method: 'POST',
        data: useKeycloakStore().userInfo,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          if (userAccount?.url && userAccount.url !== null) {
            window.location = userAccount.url;
          } else {
            this.userAccount = userAccount;
          }
          console.log('moduleCreate', userAccount);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getUserAccount(payload) {
      const { default: axios } = await import('axios');
      const user= payload !== null && payload !== undefined ? payload : useKeycloakStore().userInfo;
      console.log("userInfo",payload, useKeycloakStore());
      axios({
        url: `${path}/current`,
        method: 'POST',
        data:user,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          console.log('userAccount is ', userAccount);
          const account = userAccount.body ? userAccount.body : userAccount;
          this.userAccount = account;
          console.log('userAccount body is ', account);
        })
        .catch((err) => {
          this.createNewUservocashAccounts();
          console.log(err);
        });
    },

    /**
     * PUT /account/user/profile
     * Sends a partial profile update to the backend which applies it to Keycloak
     * via KeycloakAdminService.updateUserProfile(...).
     *
     * payload shape:
     *   {
     *     firstName?: string,
     *     lastName?: string,
     *     email?: string,
     *     updatedAttributes?: Record<string, string>  // phoneNumber, dateOfBirth, countryCode, address(JSON)
     *   }
     *
     * On success the resolved value is the fresh Keycloak UserRepresentation.
     */
    async updateUserProfile(payload) {
      const { default: axios } = await import('axios');
      const token = useKeycloakStore().token;
      if (!token) {
        return Promise.reject(new Error('No authentication token available'));
      }
      return axios({
        url: `${path}/profile`,
        method: 'PUT',
        data: payload,
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((r) => r.data)
        .then((updatedRep) => {
          // The caller (component) is responsible for reloading Keycloak user info
          // into authStore.profile — this action just resolves the backend response.
          return updatedRep;
        });
    },

    resetAccount() {
      this.userAccount = '';
    },

    async uploadProofOfId(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/upload/proofOfId`,
        method: 'POST',
        data: payload,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async uploadLogoAvatar(payload) {
      console.log('uploadLogoAvatar payload', payload);
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/logo`,
        method: 'POST',
        params: {
          accountId: payload.accountId,
          logo: payload.logo,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
          console.log(userAccount);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async updateLogoAvatar(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/logo`,
        method: 'PUT',
        params: {
          accountId: payload.accountId,
          logo: payload.logo,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
          console.log(userAccount);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async activateBusinessAccount(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/business/create`,
        method: 'POST',
        data: payload,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((businessAccount) => {
          this.userAccount = businessAccount;
          console.log('businessAccount', businessAccount);
          f7.views.main.router.navigate('/dashboard/');
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async changePublicStatus(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/publicStatus`,
        method: 'PUT',
        params: {
          accountId: payload.accountId,
          publicAccount: payload.publicAccount,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async setPaymentLimit(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/paymentLimit`,
        method: 'PUT',
        params: {
          accountId: payload.accountId,
          paymentLimit: payload.paymentLimit,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async setAccounMaintWallet(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/wallet`,
        method: 'PUT',
        params: {
          accountId: payload.accountId,
          walletId: payload.walletId,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async setAccounMaintCreditCard(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/creditcard`,
        method: 'PUT',
        params: {
          accountId: payload.accountId,
          creditcardId: payload.creditcardId,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async setAccounMaintBankAccount(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/bankaccount`,
        method: 'PUT',
        params: {
          accountId: payload.accountId,
          bankAccountId: payload.bankAccountId,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async loadAccount(payload) {
      // console.log('loadAccount called with payload:', payload, useKeycloakStore());
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/getAccountByUserId`,
        method: 'GET',
        params: {
          userId:
            payload !== null
              ? payload
              : useKeycloakStore().subject,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
          console.log(userAccount);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async loadBusinessAccount() {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/businessAccount`,
        method: 'GET',
        params: useKeycloakStore().subject,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userAccount) => {
          this.userAccount = userAccount;
          console.log(userAccount);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async loadUser(payload) {
      const { default: axios } = await import('axios');
      let type_params;
      let type_url;
      if (payload.type === 'userId') {
        type_params = { userId: payload.userId };
        type_url = '/userAccountsDetailsByUserId';
      } else if (payload.type === 'accountId') {
        type_params = { accountId: payload.accountId };
        type_url = '/accountId';
      } else if (payload.type === 'walletId') {
        type_params = { walletId: payload.walletId };
        type_url = '/userAccountsDetailsByWalletId';
      }
      console.log('userDetail params', type_params, type_url);
      axios({
        url: `${path}${type_url}`,
        method: 'GET',
        params: type_params,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((userDetail) => {
          this.userDetail = userDetail;
          console.log('userDetail', userDetail);
        })
        .catch((err) => {
          console.log(err.response.data);
          console.log(err);
        });
    },

    async getAllUsers() {
      if (!useKeycloakStore().authenticated) {
        return;
      }
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/allUsers`,
        method: 'GET',
        params: {
          userId: useKeycloakStore().subject,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
        useCache: true,
      })
        .then((r) => r.data)
        .then((users) => {
          this.users = users;
          console.log('All users', users);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    setUser(searchedUser) {
      console.log(searchedUser);
      this.searchedUser = searchedUser;
    },

    async getMyGroupList(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/myGroupList`,
        method: 'GET',
        params: {
          userId: payload
            ? payload
            : useKeycloakStore().subject,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
        useCache: true,
      })
        .then((r) => r.data)
        .then((userGroupList) => {
          this.userGroupList = userGroupList;
          console.log('userGroupList', userGroupList);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getUserByAccountNumber(payload) {
      console.log(payload);
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/accountId`,
        method: 'GET',
        params: {
          accountId: payload,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then(() => {
          this.userByAccountNumber = this.userAccount;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },

    async getClaimUserByAccountNumber(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${path}/userbyaccountnumber`,
        method: 'GET',
        params: {
          accountNumber: payload,
        },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((claimUserByAccountNumber) => {
          this.claimUserByAccountNumber = claimUserByAccountNumber;
          console.log(claimUserByAccountNumber);
          this.getusererror = '';
        })
        .catch((err) => {
          this.getusererror = err.response.data.message;
          this.claimUserByAccountNumber = '';
          console.log(err.response.data.message);
          console.log(err);
        });
    },

    resetUserByAccountNumber() {
      this.userByAccountNumber = '';
    },

    async createEntityDocuments(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: doc_path,
        method: 'POST',
        data: payload,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((documentList) => {
          this.documentList = documentList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getEntityDocuments(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: doc_path,
        method: 'GET',
        params: { entityId: payload.entityId },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((documentList) => {
          this.documentList = documentList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async editEntityDocuments(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: doc_path,
        method: 'PUT',
        data: payload,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((documentList) => {
          this.documentList = documentList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async deleteEntityDocuments(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: doc_path,
        method: 'DELETE',
        params: { docId: payload.docId, isAdmin: payload.isAdmin },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((documentList) => {
          this.documentList = documentList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async deleteFileEntityDocuments(payload) {
      const { default: axios } = await import('axios');
      axios({
        url: `${doc_path}/file`,
        method: 'DELETE',
        params: { fileId: payload.fileId, isAdmin: payload.isAdmin },
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .then((documentList) => {
          this.documentList = documentList;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async saveSurveyResults(payload) {
      const { default: axios } = await import('axios');
      return axios({
        url: `${import.meta.env.VITE_APP_URL}survey`,
        method: 'POST',
        data: payload,
        headers: {
          Authorization: `Bearer ${useKeycloakStore().token}`,
        },
      })
        .then((r) => r.data)
        .catch((err) => {
          console.log(err);
          throw err;
        });
    },
  },
});
